<template>
  <div class="by-center">
    <h6 class="text-h6 mt-8 mb-3">Список товаров</h6>


    <v-row>
      <v-col
        v-for="product in acquiring.data.orders"
        :key="product.image"
        cols="6"
        md="3"
        sm="4"
      >
        <v-card
          class="my-4"
          elevation="0"
        >
          <v-img
            contain
            height="250"
            :src="product.image"
          ></v-img>

          <v-card-title>
            Цена: {{product.sum | number}} ₽
          </v-card-title>

          <v-card-text>
            <div>
              {{product.sum | number}} = {{product.price | number}} + {{product.feeValue | number}} (оргсбор {{product.fee}}%)
            </div>

            <div class="my-4 text-subtitle-1">
              {{ product.name }}
            </div>

          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {getAcquiring} from '@/composables/acquiring'

export default {
  name: 'AcquiringDemoProducts',
  computed: {
    acquiring: getAcquiring
  }
}
</script>

<style scoped>

</style>
